"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CheckCircle = _interopRequireDefault(require("@material-ui/icons/CheckCircle"));

var _WatchLater = _interopRequireDefault(require("@material-ui/icons/WatchLater"));

var _Error = _interopRequireDefault(require("@material-ui/icons/Error"));

var _FBUIConstants = require("../../../../utils/FBUIConstants");

var _StatusChipModule = _interopRequireDefault(require("./StatusChip.module.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * # Status Chip
 * Simple Foodbomb Button Component
 *
 * ## Modifiers
 * ### Type
 * ```
 * ['success', 'failed', 'pending']
 * ```
 *
 * ## PropTypes:
 * ```js
 *  StatusChip.propTypes = {
 *    title: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]).isRequired,
 *    type: PropTypes.oneOf(Object.values(STATUS_CHIP_TYPES)).isRequired,
 *    hideIcon: PropTypes.bool,
 *    className: PropTypes.string,
 *    iconOverride: PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.node]).isRequired,
 *  };
 * ```
 */
var StatusChip = function StatusChip(_ref) {
  var title = _ref.title,
      type = _ref.type,
      hideIcon = _ref.hideIcon,
      className = _ref.className,
      iconOverride = _ref.iconOverride;
  var statusChipStyles = [_StatusChipModule.default.StatusChip];

  if (type) {
    statusChipStyles.push(_StatusChipModule.default[type.toLowerCase()]);
  }

  var getIcon = function getIcon() {
    if (iconOverride) {
      return iconOverride;
    }

    if (!type) {
      return /*#__PURE__*/_react.default.createElement(_CheckCircle.default, {
        className: _StatusChipModule.default.StatusChip__icon
      });
    }

    switch (type.toLowerCase()) {
      case _FBUIConstants.STATUS_CHIP_TYPES.FAILED:
        return /*#__PURE__*/_react.default.createElement(_Error.default, {
          className: _StatusChipModule.default.StatusChip__icon
        });

      case _FBUIConstants.STATUS_CHIP_TYPES.PENDING:
        return /*#__PURE__*/_react.default.createElement(_WatchLater.default, {
          className: _StatusChipModule.default.StatusChip__icon
        });

      default:
        return /*#__PURE__*/_react.default.createElement(_CheckCircle.default, {
          className: _StatusChipModule.default.StatusChip__icon
        });
    }
  };

  var icon = getIcon();
  return /*#__PURE__*/_react.default.createElement("div", {
    className: [_StatusChipModule.default.StatusChipContainer, className].join(' ')
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: statusChipStyles.join(' ')
  }, !hideIcon && icon, title));
};

StatusChip.propTypes = {
  title: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.node]).isRequired,
  type: _propTypes.default.oneOf(Object.values(_FBUIConstants.STATUS_CHIP_TYPES)).isRequired,
  hideIcon: _propTypes.default.bool,
  className: _propTypes.default.string,
  iconOverride: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object, _propTypes.default.node]).isRequired
};
var _default = StatusChip;
exports.default = _default;

//# sourceMappingURL=StatusChip.js.map